import 'regenerator-runtime/runtime';
import wpstgReAuth from './wpstg-re-auth';

class WpstgAuthCheck {
  constructor(wpstgObject = wpstg) {
    this.wpstgObject = wpstgObject;
    this.count = 0;
    this.status = true;
    this.isAuthenticated = true;
  }

  /**
   * Start checking user authentication
   *
   * @return {void}
   */
  start() {
    if (this.status) {
      setTimeout(() => {
        this.checkUserAuthentication();
      }, 1000);
    }
  }

  /**
   * @return {void}
   */
  stop() {
    this.resetCount();
    this.status = false;
  }

  /**
   * @return {void}
   */
  resetCount() {
    this.count = 0;
  }

  /**
  * @return {void}
  */
  async checkUserAuthentication() {
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: 'wpstg_check_user_is_authenticated',
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      if (data.wpAuthCheck === false) {
        this.count++;
      }

      this.isAuthenticated = data.wpAuthCheck;
      if (this.count === 2) {
        this.stop();
        this.createAuthCheckElements(data.redirectUrl);
        return;
      }

      this.start();
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  /**
   * @param redirectUrl
   * @return {void}
   */
  createAuthCheckElements(redirectUrl) {
    const isAlreadyAppended = document.getElementById('wpstg-auth-check-wrap') !== null;

    if (isAlreadyAppended) {
      document.getElementById('wpstg-auth-check-wrap').remove();
    }

    const wpAuthCheckWrap = document.createElement('div');
    wpAuthCheckWrap.id = 'wpstg-auth-check-wrap';
    wpAuthCheckWrap.classList.add('hidden');

    const wpAuthCheckBg = document.createElement('div');
    wpAuthCheckBg.id = 'wpstg-auth-check-bg';

    const wpAuthCheckDialog = document.createElement('div');
    wpAuthCheckDialog.id = 'wpstg-auth-check';

    const wpAuthCheckForm = document.createElement('div');
    wpAuthCheckForm.id = 'wpstg-auth-check-form';
    wpAuthCheckForm.classList.add('loading');
    wpAuthCheckForm.dataset.src = redirectUrl + '?interim-login=1&wp_lang=en_US';

    const wpAuthCheckFallback = document.createElement('div');
    wpAuthCheckFallback.classList.add('wpstg-auth-fallback');

    const wpAuthCheckExpired = document.createElement('p');
    wpAuthCheckExpired.innerHTML = '<b class="wpstg-auth-fallback-expired" tabindex="0">Session expired</b>';

    const wpAuthCheckLoginLink = document.createElement('p');
    wpAuthCheckLoginLink.innerHTML = `<a href="${redirectUrl}" target="_blank">Please log in again.</a> The login page will open in a new tab. After logging in you can close it and return to this page.`;

    wpAuthCheckDialog.append(wpAuthCheckForm, wpAuthCheckFallback);
    wpAuthCheckFallback.append(wpAuthCheckExpired, wpAuthCheckLoginLink);
    wpAuthCheckWrap.append(wpAuthCheckBg, wpAuthCheckDialog);
    document.body.appendChild(wpAuthCheckWrap);
    wpstgReAuth.shows();
  }
}

const wpstgAuthCheck = new WpstgAuthCheck();
export default wpstgAuthCheck;

